import { render, staticRenderFns } from "./ElectricalProtection.vue?vue&type=template&id=22988045&"
import script from "./ElectricalProtection.vue?vue&type=script&lang=js&"
export * from "./ElectricalProtection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports